<template>
    <div class="careers-application-form">
        <p>Настоящата форма има за цел да събере цялата информация, която ни е необходима да регистрираме и обработим Вашето кандидатстване за наличните в момента свободни работни места при нас. Приканваме Ви да бъдете възможно най-изчерпателни и точни. Посочените данни ще се ползват единствено от „Алкомет“ АД и само за целите на въпросната кандидатура.</p>
        <form class="application-form" id="applicationForm" enctype="multipart/form-data" @submit.prevent="submit()">
          <label for="applicationFiles" class="download-file">
              <div class="download-file-left">
                <img src="/static/img/careers/application_form/upload.png" alt="Upload">
                <div class="download-file-left-texts">
                  <p>Прикачи файлове (до 5 файла, 9.8MB максимално)</p>
                  <span v-if="!selectedFiles.length">Прикачени файлове</span>
                  <span v-else>
                    <span v-for="(file, index) in selectedFiles" :key="file.name">{{file}}<span v-if="selectedFiles.length - 1 > index">, </span></span>
                  </span>
                </div>
              </div>
              <div class="download-file-right">
                <p>Прикачи</p>
                <svg class="folder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.73 59.75"><title>Прикачи</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M69.7,24.89h9L61.3,59.75H0V10H26.33l10-10H69.7ZM5,14.94V49.21L17.15,24.89H64.73V5H38.39l-10,10ZM58.19,54.77l12.45-24.9H20.23L7.74,54.77Z"/></g></g></svg>
              </div>
          </label>
          <input class="input-hide" type="file" id="applicationFiles" ref="applicationFiles" @change="handleFileUpload()" multiple>
          <!-- 0 - ENTRY -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[0] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(0)">Начало</h6>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[0] }">
              <p>Изберете позиция:</p>
              <select class="application-form-select" v-model="request.position">
                <option v-for="(p, index) in openPositions" :key="`position-${index}`" v-if="isCareerVisible(p)" :value="p.title">{{p.title}}</option>
              </select>
            </div>
          </div>
          <!-- 1 - PERSONAL DATA -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[1] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(1)">Лични данни</h6>
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.name" placeholder="Име, презиме и фамилия">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.pid" placeholder="ЕГН">
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[1] }">
              <p>Пол:</p>
              <select class="application-form-select" v-model="request.personal.sex">
                <option value="Мъж">Мъж</option>
                <option value="Жена">Жена</option>
              </select>
            </div>
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.birthplace" placeholder="Място на раждане">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.cardId" placeholder="Номер на лична карта">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.cardIssueDate" placeholder="Дата на издаване">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[1] }" type="text" v-model="request.personal.cardIssuePlace" placeholder="Издадена от МВР">
          </div>
          <!-- 2 - ADDRESS -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[2] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(2)">Данни за връзка</h6>
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[2] }" type="text" v-model="request.address.city" placeholder="Град">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[2] }" type="text" v-model="request.address.street" placeholder="Улица">
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[2] }">
              <input class="application-form-input" type="text" v-model="request.address.entr" placeholder="Вх.">
              <input class="application-form-input" type="text" v-model="request.address.floor" placeholder="Ет.">
              <input class="application-form-input" type="text" v-model="request.address.apt" placeholder="Ап.">
            </div>
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[2] }" type="email" v-model="request.address.email" placeholder="E-mail">
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[2] }" type="text" v-model="request.address.phone" placeholder="Телефон">
          </div>
          <!-- 3 - FAMILY -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[3] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(3)">Семеен статус</h6>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[3] }">
              <p>Семеен статус:</p>
              <select class="application-form-select" v-model="request.family.familyStatus">
                <option value="Неженен/неомъжена">Неженен/неомъжена</option>
                <option value="Женен/омъжена">Женен/омъжена</option>
                <option value="Разведен/а">Разведен/а</option>
                <option value="Вдовец/вдовица">Вдовец/вдовица</option>
              </select>
            </div>
            <!-- CHILDREN COUNT -->
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[3] }">
              <p>Деца под 18 години:</p>
              <select class="application-form-select" v-model="request.family.childrenCount">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </div>
            <!-- CHILDREN DATA -->
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[3] }" v-if="request.family.childrenCount" v-for="(child, index) in +request.family.childrenCount" :key="`child-${child}`">
              <input class="application-form-input" type="text" v-model="request.family.children[index].name" placeholder="Име, презиме и фамилия">
              <input class="application-form-input" type="text" v-model="request.family.children[index].birthday" placeholder="Дата на раждане">
              <input class="application-form-input" type="text" v-model="request.family.children[index].sex" placeholder="Пол (м/ж)">
            </div>
          </div>
          <!-- 4 - EDUCATION -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[4] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(4)">Образование</h6>
            <p :class="{ 'p-active' : isActive[4] }">Средно образование</p>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[4] }" v-for="(h, index) in request.education.highschool" :key="`school-${index}`">
              <input class="application-form-input" type="text" v-model="h.name" :placeholder="`${+index + 1}. Учебно заведение`">
              <input class="application-form-input" type="text" v-model="h.specialty" placeholder="Специалност">
            </div>
            <p :class="{ 'p-active' : isActive[4] }">Висше образование</p>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[4] }" v-for="(u, index) in request.education.university" :key="`uni-${index}`">
              <input class="application-form-input" type="text" v-model="u.name" :placeholder="`${+index + 1}. Учебно заведение`">
              <input class="application-form-input" type="text" v-model="u.specialty" placeholder="Специалност">
              <input class="application-form-input" type="text" v-model="u.degree" placeholder="Степен">
            </div>
          </div>
          <!-- 5 - QUALIFICATIONS -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[5] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(5)">Квалификации</h6>
            <p :class="{ 'p-active' : isActive[5] }">Компютърни умения</p>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[5] }">
              <p>Word:</p>
              <select class="application-form-select" v-model="request.qualifications.word">
                <option value="Основно">Основно</option>
                <option value="Средно">Средно</option>
                <option value="Отлично">Отлично</option>
              </select>
            </div>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[5] }">
              <p>Excel:</p>
              <select class="application-form-select" v-model="request.qualifications.excel">
                <option value="Основно">Основно</option>
                <option value="Средно">Средно</option>
                <option value="Отлично">Отлично</option>
              </select>
            </div>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[5] }">
              <p>Интернет:</p>
              <select class="application-form-select" v-model="request.qualifications.internet">
                <option value="Основно">Основно</option>
                <option value="Средно">Средно</option>
                <option value="Отлично">Отлично</option>
              </select>
            </div>
            <p :class="{ 'p-active' : isActive[5] }">Други специализации и правоспособност</p>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[5] }" v-for="(q, index) in request.qualifications.others" :key="`qualification-${index}`">
              <input class="application-form-input" type="text" v-model="q.qualification" :placeholder="`${+index + 1}. Квалификация`">
              <input class="application-form-input" type="text" v-model="q.docNum" placeholder="Документ №">
              <input class="application-form-input" type="text" v-model="q.from" placeholder="Издаден от">
            </div>
          </div>
          <!-- 6 - LANGUAGES -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[6] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(6)">Езикови умения</h6>
            <p :class="{ 'p-active' : isActive[6] }">Посочете вляво езиците, по които имате известни познания. Различните умения (Четене, Говорене и Писане) оценете сами по петобална система, като 5 е най-висока оценка.</p>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[6] }" v-for="(l, index) in request.languages" :key="`lang-${index}`">
              <input class="application-form-input" type="text" v-model="l.lang" :placeholder="`${+index + 1}. Въведете език`">
              <select class="application-form-select" v-model="l.read">
                <option disabled selected>Четене</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <select class="application-form-select" v-model="l.speak">
                <option disabled selected>Говорене</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
              <select class="application-form-select" v-model="l.write">
                <option disabled selected>Писане</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
          <!-- 7 - WORK EXPRERIENCE -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[7] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(7)">Професионален опит</h6>
            <p :class="{ 'p-active' : isActive[7] }">Въведете основна информация за Вашия професионален опит, като започнете от Вашата последна месторабота.</p>
            <template v-for="(job, index) in request.work">
              <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[7] }" :key="`job-${index}-row-1`">
                <input class="application-form-input" type="text" v-model="job.job" :placeholder="`${+index + 1}. Месторабота`">
                <input class="application-form-input" type="text" v-model="job.duration" placeholder="от - до">
              </div>
              <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[7] }" :key="`job-${index}-row-2`">
                <input class="application-form-input" type="text" v-model="job.position" placeholder="Заемана длъжност">
                <input class="application-form-input" type="text" v-model="job.quitReason" placeholder="Причини за напускане">
              </div>
            </template>
          </div>
          <!-- 8 - OTHERS -->
          <div class="application-form-group" :class="{ 'application-form-group-active' : isActive[8] }">
            <h6 class="application-form-title-toggle" @click="toggleFormGroup(8)">Допълнителни данни</h6>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[8] }">
              <p>Стаж в "Алкомет" АД:</p>
              <select class="application-form-select" v-model="request.others.internship">
                <option value="Да">Да</option>
                <option value="Не">Не</option>
              </select>
            </div>
            <input class="application-form-input" :class="{ 'application-form-input-active' : isActive[8] }" type="text" v-model="request.others.workExperience" placeholder="Общ трудов стаж">
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[8] }">
              <p>Познати в "Алкомет" АД:</p>
              <select class="application-form-select" v-model="request.others.hasContactsInAlcomet">
                <option value="Да">Да</option>
                <option value="Не">Не</option>
              </select>
            </div>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[8] }">
              <p>Съдебно минало:</p>
              <select class="application-form-select" v-model="request.others.isSued">
                <option value="Да">Да</option>
                <option value="Не">Не</option>
              </select>
            </div>
            <div class="application-form-input-row" :class="{ 'application-form-input-row-active' : isActive[8] }">
              <p>Пенсиониран ли сте:</p>
              <select class="application-form-select" v-model="request.others.isRetired">
                <option value="Да">Да</option>
                <option value="Не">Не</option>
              </select>
            </div>
          </div>
          <div class="gdpr-and-submit">
            <p>С изпращането на това запитване вие се съгласявате с <router-link to="/personal-data">Нашата политика за поверителност на потребителските данни</router-link></p>
            <button class="btn-submit" type="submit" >
              <transition name="sliding" mode="out-in">
                <span v-if="!isLoading" key="is-not-loading">Кандидатствай</span>
                <span v-else class="loading-wrapper" key="is-loading">
                  <span class="loading loading-0"></span>
                  <span class="loading loading-1"></span>
                  <span class="loading loading-2"></span>
                </span>
              </transition>
            </button>
          </div>
        </form>
        <transition name="slide">
          <div class="application-success" v-if="applicationSent">
            <div>
              <h1>Формата е изпратена успешно!</h1>
              <p>Ще бъдете пренасочени към началната страница след 5 секунди...</p>
            </div>
          </div>
        </transition>
    </div>
</template>

<script>
import Docs from "../shared/Docs";
export default {
  components: {
    appDocs: Docs
  },
  data() {
    return {
      request: {
        // 0 - ENTRY
        position: "",
        // 1 - PERSONAL DATA
        personal: {
          name: "",
          pid: "",
          sex: "Мъж",
          birthplace: "",
          cardId: "",
          cardIssueDate: "",
          cardIssuePlace: ""
        },
        // 2 - ADDRESS
        address: {
          city: "",
          street: "",
          entr: "",
          floor: "",
          apt: "",
          phone: "",
          email: ""
        },
        // 3 - FAMILY
        family: {
          familyStatus: "Неженен/неомъжена",
          childrenCount: 0,
          children: {
            0: {
              name: "",
              birthday: "",
              sex: ""
            },
            1: {
              name: "",
              birthday: "",
              sex: ""
            },
            2: {
              name: "",
              birthday: "",
              sex: ""
            }
          }
        },
        // 4 - EDUCATION
        education: {
          highschool: {
            0: {
              name: "",
              specialty: ""
            },
            1: {
              name: "",
              specialty: ""
            }
          },
          university: {
            0: {
              name: "",
              specialty: "",
              degree: ""
            },
            1: {
              name: "",
              specialty: "",
              degree: ""
            }
          }
        },
        // 5 - QUALIFICATIONS
        qualifications: {
          word: "Основно",
          excel: "Основно",
          internet: "Основно",
          others: {
            0: { qualification: "", docNum: "", from: "" },
            1: { qualification: "", docNum: "", from: "" },
            2: { qualification: "", docNum: "", from: "" },
            3: { qualification: "", docNum: "", from: "" },
            4: { qualification: "", docNum: "", from: "" },
            5: { qualification: "", docNum: "", from: "" }
          }
        },
        // 6 - LANGUAGES
        languages: {
          0: { lang: "", read: "Четене", speak: "Говорене", write: "Писане" },
          1: { lang: "", read: "Четене", speak: "Говорене", write: "Писане" },
          2: { lang: "", read: "Четене", speak: "Говорене", write: "Писане" },
          3: { lang: "", read: "Четене", speak: "Говорене", write: "Писане" },
          4: { lang: "", read: "Четене", speak: "Говорене", write: "Писане" }
        },
        // 7 - WORK EXPERIENCE
        work: {
          0: { job: "", duration: "", position: "", quitReason: "" },
          1: { job: "", duration: "", position: "", quitReason: "" },
          2: { job: "", duration: "", position: "", quitReason: "" },
          3: { job: "", duration: "", position: "", quitReason: "" },
          4: { job: "", duration: "", position: "", quitReason: "" },
          5: { job: "", duration: "", position: "", quitReason: "" }
        },
        // 8 - OTHERS
        others: {
          internship: "Не",
          workExperience: "",
          hasContactsInAlcomet: "Не",
          isSued: "Не",
          isRetired: "Не"
        },
        applicationFiles: ""
      },
      selectedFiles: [],
      applicationSent: false,
      isLoading: false,
      isActive: [false, false, false, false, false, false, false, false, false],
      openPositions: []
    };
  },
  methods: {
    getOpenPositions() {
      this.$http
        .get(`${process.env.ROOT_API}/careers`)
        .then(response => {
          response.data.careers.forEach(item => {
            this.openPositions.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    },
    isCareerVisible(career) {
      const start = new Date(career.startDate).getTime();
      const end = new Date(career.endDate).getTime();
      let now = new Date();
      now.setHours(0, 0, 0, 0);
      now = now.getTime();
      if (start < now && now <= end) {
        return true;
      }
      return false;
    },
    toggleFormGroup(index) {
      if (this.isActive[index]) {
        this.$set(this.isActive, index, false);
      } else {
        this.isActive = [
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        ];
        this.$set(this.isActive, index, true);
      }
    },
    handleFileUpload() {
      if (this.$refs.applicationFiles.files.length < 6) {
        this.selectedFiles = [];
        this.request.files = this.$refs.applicationFiles.files;
        Array.from(this.request.files).forEach(file => {
          this.selectedFiles.push(file.name);
          if (file.size > 10000000) {
            alert("You cannot upload files bigger than 9.8MB");
            this.selectedFiles = [];
            return;
          }
        });
      } else {
        alert("You can upload up to 5 files");
      }
    },
    isValid() {
      if (!this.selectedFiles.length) {
        alert("Трябва да прикачите поне един файл!");
        return false;
      }
      return true;
    },
    submit() {
      if (this.isValid()) {
        this.isLoading = true;

        let data = new FormData();

        data.append("data", JSON.stringify(this.request));

        for (let i = 0; i < this.$refs.applicationFiles.files.length; i++) {
          let file = this.$refs.applicationFiles.files[i];
          data.append("file", file);
        }

        this.$http
          .post(`${process.env.ROOT_API}/application-form`, data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
          })
          .then(response => {
            if (response.data.success) {
              this.applicationSent = true;
              // this.selectedFiles = [];
              // this.request = {
              //   name: "",
              //   phone: "",
              //   email: "",
              //   applicationFiles: ""
              // };
              setTimeout(() => {
                this.$router.push("/");
                // this.applicationSent = false;
              }, 5000);
            } else {
              alert("Something went wrong. Refresh the page and try again");
            }
            this.isLoading = false;
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
          });
      }
    }
  },
  mounted() {
    this.getOpenPositions();
  }
};
</script>

<style scoped>
.careers-application-form {
  align-items: center;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.careers-application-form > h6 {
  font-size: 20px;
  width: 60%;
}
.careers-application-form > p {
  font-size: 19px;
  line-height: 32px;
  margin: 20px auto;
  text-align: justify;
  width: 60%;
}
/* FORM */
.application-form-group {
  align-items: center;
  background-color: #dbebf485;
  border-radius: 6px;
  border: 1px solid rgba(112, 112, 112, 0.09);
  display: flex;
  flex-direction: column;
  margin: 5px 0;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.application-form-title-toggle {
  color: #00305b;
  cursor: pointer;
  font-size: 16px;
  padding: 12px 15px;
  position: relative;
  width: 100%;
}
.application-form-title-toggle:hover {
  background-color: #dde7ee;
}
.application-form-title-toggle::after {
  content: "I";
  font-family: "alcomet";
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
.application-form-group > p {
  /* align-items: flex-end; */
  color: #00305b;
  display: flex;
  font-size: 14px;
  height: 0;
  /* margin-top: 20px; */
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: calc(100% - 60px);
}
.application-form-group > .p-active {
  /* height: 40px; */
  height: initial;
  padding: 15px 0;
}
.application-form-group-active {
  padding-bottom: 30px;
}
.application-form-group-active::after {
  transform: translateY(-50%) rotate(180deg);
}
.application-form {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin: 0 0 20px;
  width: 60%;
}
.application-form-input {
  background-color: transparent;
  border: none;
  color: #00305b;
  font-size: 14px;
  height: 0;
  margin: 0 10px;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: calc(100% - 60px);
}
.application-form-input-row > .application-form-input {
  border-bottom: 1px solid rgba(112, 112, 112, 0.09);
  height: 50px;
  margin: 0 20px 0 0;
}
.application-form-input-active {
  border-bottom: 1px solid rgba(112, 112, 112, 0.09);
  height: 50px;
  /* padding: 20px 10px 10px; */
}
.application-form-input::-moz-placeholder {
  color: rgba(0, 48, 91, 0.6);
  font-size: 14px;
}
.application-form-input:-moz-placeholder {
  color: rgba(0, 48, 91, 0.6);
  font-size: 14px;
}
.application-form-input::-webkit-input-placeholder {
  color: rgba(0, 48, 91, 0.6);
  font-size: 14px;
}
.application-form-input:-ms-input-placeholder {
  color: rgba(0, 48, 91, 0.6);
  font-size: 14px;
}
.application-form-input-row {
  align-items: flex-end;
  display: flex;
  height: 0;
  overflow: hidden;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: calc(100% - 60px);
}
.application-form-input-row-active {
  height: 50px;
  overflow: initial;
}
.application-form-input-row .application-form-select {
  width: 100%;
  margin-right: 20px;
}
.application-form-input-row .application-form-input {
  width: 100%;
  margin-right: 20px;
}
.application-form-input-row .application-form-input:last-child,
.application-form-input-row .application-form-select:last-child {
  margin-right: 0;
}
.application-form-input-row p {
  color: #00305b;
  font-size: 14px;
  margin-right: 20px;
  padding: 0 0 12px 0;
  white-space: nowrap;
}
.application-form-select {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid rgba(112, 112, 112, 0.09);
  color: #00305b;
  font-size: 14px;
  padding: 10px 10px 10px 6px;
  width: calc(100% - 60px);
}
.margin-top-15 {
  margin-top: 15px;
}
/* DOWNLOAD/UPLOAD BUTTON */
.input-hide {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.download-file {
  align-items: center;
  background-color: #dbebf485;
  border: 1px solid rgba(112, 112, 112, 0.09);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  height: 60px;
  justify-content: space-between;
  margin-bottom: 7px;
  width: 60%;
}
.download-file:hover {
  background-color: #dde7ee;
}
.download-file-left {
  align-items: center;
  display: flex;
}
.download-file-left img {
  height: 40px;
  margin: 0 5px;
  width: 40px;
}
.download-file-left-texts {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}
.download-file-left p {
  color: #002e73;
  font-size: 16px;
}
.download-file-left span {
  color: #989898;
  font-size: 12px;
}
.download-file-right {
  display: flex;
}
.download-file-right p {
  align-items: center;
  color: #002e73;
  display: flex;
  font-size: 14px;
  font-weight: 600;
}
.download-file-right span {
  color: #002e73;
  display: inline-block;
  font-size: 18px;
  margin: 0 13px 0 10px;
}
.folder-svg {
  fill: #002e73;
  height: 20px;
  margin: 0 13px 0 10px;
  width: 20px;
}
.application-form .download-file {
  margin-top: 26px;
  width: 100%;
}
.gdpr-and-submit {
  align-items: center;
  display: flex;
}
.gdpr-and-submit > p {
  font-size: 12px;
  padding-right: 20px;
}
/* SUBMIT */
.btn-submit {
  align-items: center;
  background-color: transparent;
  border: 1px solid #588cc1;
  border-radius: 30px;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  overflow: hidden;
  margin: 15px 0;
  padding: 8px 20px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 180px;
}
.btn-submit:hover {
  background-color: #dde7ee;
}
.loading-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
}
.loading {
  border-radius: 100%;
  background: #009dc6;
  height: 5px;
  display: inline-block;
  margin-right: 5px;
  width: 5px;
}
.loading-0 {
  animation: bounce 1s infinite;
  animation-delay: 0.1s;
}
.loading-1 {
  animation: bounce 1s infinite;
  animation-delay: 0.3s;
}
.loading-2 {
  animation: bounce 1s infinite ease;
  animation-delay: 0.5s;
  margin-right: 0;
}
@keyframes bounce {
  0%,
  100% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
}
.application-success {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}
.application-success div {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.95);
  -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 100px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 200px;
  padding: 20px;
  width: 400px;
}
.application-success h1 {
  font-size: 22px;
  text-align: center;
}
.application-success p {
  margin-top: 15px;
  text-align: center;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.4s ease;
}
.slide-leave-to,
.slide-enter {
  opacity: 0;
  transform: translateY(-25%);
}
.sliding-enter-active,
.sliding-leave-active {
  transition: all 0.2s ease;
}
.sliding-enter {
  opacity: 0;
  transform: translateX(-100%);
}
.sliding-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
@media screen and (max-width: 1280px) {
  .application-form {
    width: 80%;
  }
  .btn-submit {
    font-size: 12px;
  }
}
@media screen and (max-width: 1000px) {
  .careers-application-form > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .careers-application-form > h6,
  .application-form,
  .download-file {
    width: calc(100% - 60px);
  }
}
@media screen and (max-width: 600px) {
  .careers-application-form > h6 {
    font-size: 18px;
  }
  .download-file {
    height: 50px;
  }
  .download-file-left img {
    width: 35px;
    height: 35px;
  }
  .download-file-left p,
  .download-file-right span {
    font-size: 14px;
  }
  .download-file-left span {
    font-size: 10px;
  }
  .download-file-right p {
    font-size: 12px;
  }
}
@media screen and (max-width: 440px) {
  .download-file-right p {
    display: none;
  }
  .download-file-left p {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/careers/ApplicationForm.vue